import { type WebSection } from '@wbk/contentful/api';
import FeaturedGuides from '@/components/sections/booklet/Featured';
import HeroSection from '@/components/sections/booklet/Hero';
import HowToUse from '@/components/sections/booklet/HowToUse';
import AllGuides from '@/components/sections/booklet/AllGuides';
import RecommendedForYou from '../sections/booklet/Recommended';

const BookletSections = ({ section }: { section?: WebSection }) => {
  switch (section?.renderType) {
    case 'hero-image':
    case 'hero':
      return <HeroSection section={section} />;
    case 'cards':
      return <FeaturedGuides section={section} />;

    case 'cards-grid':
      return <AllGuides section={section} />;

    case 'advertise':
      return <RecommendedForYou section={section} />;

    case 'about':
      return <HowToUse section={section} />;
    default:
      return <></>;
  }
};

export default BookletSections;
